// Service records (客服记录): how to reach the customer behind each call.
// The call list gives the caller number plus what the caller said (masked
// email, order numbers); ecommerce tickets started from a call add the email
// and order number the buyer submitted. Phone > email > order number.

export const callRefs = (call) => [call?.call_id, call?.session_id].filter(Boolean);

// Ticket contact items arrive keyed by the call reference they came from.
export const mergeTicketContacts = (calls, ticketItems) => {
  const byRef = new Map();
  for (const item of ticketItems || []) {
    const ref = item?.source_call_session_ref;
    if (!ref) continue;
    const seen = byRef.get(ref) || { hasEmail: false, orders: [], tickets: [] };
    if (item.has_contact_email) seen.hasEmail = true;
    if (item.order_number && !seen.orders.includes(item.order_number)) seen.orders.push(item.order_number);
    if (item.ticket_number && !seen.tickets.includes(item.ticket_number)) seen.tickets.push(item.ticket_number);
    byRef.set(ref, seen);
  }
  return (calls || []).map((call) => {
    const matches = callRefs(call).map((ref) => byRef.get(ref)).filter(Boolean);
    if (!matches.length) return call;
    const contact = call.contact || {};
    const orders = [...(contact.order_numbers || [])];
    matches.forEach((m) => m.orders.forEach((o) => { if (!orders.includes(o)) orders.push(o); }));
    return {
      ...call,
      contact: {
        ...contact,
        has_email: Boolean(contact.has_email || matches.some((m) => m.hasEmail)),
        order_numbers: orders,
      },
      ticket_numbers: matches.flatMap((m) => m.tickets),
    };
  });
};

export const maskPhone = (number) => {
  const digits = String(number || '').replace(/\D/g, '');
  return digits.length >= 7 ? `•••${digits.slice(-4)}` : '';
};

// Badges in priority order; an empty list means an anonymous visitor.
export const contactBadges = (call, lang = 'zh') => {
  const zh = lang === 'zh';
  const contact = call?.contact || {};
  const badges = [];
  const hasPhone = contact.has_phone ?? Boolean(maskPhone(call?.caller_number));
  if (hasPhone) badges.push({ kind: 'phone', label: `${zh ? '电话' : 'Phone'} ${maskPhone(call?.caller_number)}`.trim() });
  if (contact.has_email) {
    const masked = (contact.emails_masked || [])[0];
    badges.push({ kind: 'email', label: masked ? `${zh ? '邮箱' : 'Email'} ${masked}` : (zh ? '邮箱' : 'Email') });
  }
  (contact.order_numbers || []).slice(0, 2).forEach((order) => badges.push({ kind: 'order', label: `${zh ? '订单' : 'Order'} ${order}` }));
  return badges;
};

export const CONTACT_FILTERS = {
  all: {},
  email: { has_email: true },
  order: { has_order: true },
  none: { has_email: false, has_order: false },
};
